/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Meta_DescInputs */

const en_mk_meta_desc = /** @type {(inputs: Mk_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build with teammates using their own AI, or orchestrate agents in the cloud or locally. Share plans, task ownership, evidence and reviews in Bystep.`)
};

const id_mk_meta_desc = /** @type {(inputs: Mk_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build bersama rekan dengan AI masing-masing, atau atur tim agent di cloud maupun komputer sendiri. Bagikan rencana, tugas, bukti, dan review lewat Bystep.`)
};

/**
* | output |
* | --- |
* | "Build with teammates using their own AI, or orchestrate agents in the cloud or locally. Share plans, task ownership, evidence and reviews in Bystep." |
*
* @param {Mk_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_meta_desc = /** @type {((inputs?: Mk_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_meta_desc(inputs)
	return en_mk_meta_desc(inputs)
});